(function () {
    'use strict';
    angular.module('Directives').directive('bbaMapDisplay', bbaMapDisplay);
    bbaMapDisplay.$inject = [
        'MapService',
        '$timeout',
        'toastr'
    ];
    function bbaMapDisplay(
        MapService,
        $timeout,
        toastr
    ) {
        return {
            restrict: 'E',
            scope: {
                markers: '=',
            },
            template: '<div style="height: 100%; width: 100%" id="map"></div>',
            link: bbaMapDisplayLink
        }

        function bbaMapDisplayLink($scope) {
            let map;

            const currentMarkers = [];
            const currentRouteLines = [];

            init();

            function init() {
                $timeout(() => {
                    initMap();
                    $scope.$watch('markers', (value) => {
                        if (value.length < 1) { return; }
                        initMarkers();
                    }, true);
                }, 1000);
            }

            function initMap() {
                map = L.map('map');
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    maxZoom: 19
                }).addTo(map);
            }

            function initMarkers() {
                currentMarkers.forEach(marker => map.removeLayer(marker));
                currentRouteLines.forEach(line => map.removeLayer(line));

                MapService.route(data => {
                    if (!data.trip || !data.trip.legs[0].shape) {
                        console.error("No route found:", data);
                        alert("No route data returned from Valhalla!");
                        return;
                    }

                    data.trip.legs.forEach(leg => {
                        const encoded = leg.shape;
                        const latLngs = polyline.decode(encoded, 6);
                        const routeLine = L.polyline(latLngs, {
                            color: '#3388ff',
                            weight: 6,
                            opacity: 0.9,
                            lineCap: 'round',
                            lineJoin: 'round'
                        }).addTo(map);

                        currentRouteLines.push(routeLine);
                        map.fitBounds(routeLine.getBounds(), { padding: [50, 50] });
                    });

                    for (let i = 0; i < data.trip.locations.length; i++) {
                        const { lat, lon } = data.trip.locations[i];
                        const marker = L.marker({ lat, lon }, {
                            icon: L.divIcon({
                                className: `number_marker ${getMarkerClass(i, data.trip.locations)}`,
                                html: `<span>${i + 1}</span>`,
                                iconSize: [30, 30],
                                iconAnchor: [15, 30],
                                popupAnchor: [0, -30]
                            })
                        }).addTo(map)
                            .bindPopup($scope.markers[i].jobId || $scope.markers[i].driverName);
                        currentMarkers.push(marker);
                    }
                }, error => {
                    toastr.error(error.message, 'Error');
                }, getPayload())
            }

            function getPayload() {
                const locations = $scope.markers.map(loc => ({
                    lat: loc.locationData.lat,
                    lon: loc.locationData.lng,
                    "type": "break",
                    "search_radius": 1500
                }))
                return {
                    "locations": locations,
                    "costing": "truck",
                    "directions_options": {
                        "units": "kilometers",
                        "language": "en"
                    },
                    "alternatives": 2
                };
            }

            function getMarkerClass(curIndex, locations) {
                if (curIndex === 0) { return 'start_marker' }
                if (curIndex === locations.length - 1) { return 'end_marker' }
                return 'normal_marker';
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/maps/bbaMapDisplay.js